import type React from 'react';

type ChatTextAreaProps = {
  spanRef: React.RefObject<HTMLSpanElement>;
  messagePlaceholder: string;
  handleChange: (e: React.FormEvent<HTMLSpanElement>) => void;
  shouldSubmit: (e: React.KeyboardEvent<HTMLSpanElement>) => void;
  content: string;
};

const ChatTextArea: React.FC<ChatTextAreaProps> = (props) => {
  const { spanRef, messagePlaceholder, handleChange, shouldSubmit, content } =
    props;
  const CHARACTER_LIMIT = 20000;

  const handleInputChange = (e) => {
    const text = e.target.innerText;
    if (text.length > CHARACTER_LIMIT) {
      e.target.innerText = text.substring(0, CHARACTER_LIMIT);
      alert(`Character limit of ${CHARACTER_LIMIT} exceeded`);
    }
    handleChange(e);
  };

  return (
    <span
      className='message-box-input-area'
      ref={spanRef}
      data-placeholder={messagePlaceholder}
      contentEditable
      suppressContentEditableWarning
      onInput={handleInputChange}
      onKeyDown={shouldSubmit}>
      {content}
    </span>
  );
};

export default ChatTextArea;
